module.exports = __webpack_public_path__ + "img/IconMedicationTherapyManagement.270b1b63.svg";